import {create} from "zustand";

export const useDeliveryStore = create((set) => ({
    shippingProviders: [],
    pickupTimes: [],
    setShippingProviders: (shippingProviders) => set({shippingProviders}),
    setPickupTime: (pickupTimes) => set({pickupTimes}),
}));
